export default __webpack_public_path__ + "static/media/twitter-square-brands.6a1f3411.svg";